export default {
    "name": "CourseDetail",
    "kind": "HoudiniQuery",
    "hash": "61a8343ebf1d37ef18fa6976ab7c9f3e94347f221da0e44926a38b2cce149176",

    "raw": `query CourseDetail($slug: String!) {
  course(where: {slug: $slug}) {
    id
    keyTakeaways
    name
    outline
    shortDescription
    slug
    updatedAt
    publishedDate
    thumbnail {
      ...Image
      id
    }
    featuredThumbnail {
      ...Image
      id
    }
    skillLevel
    timeToComplete
    lessons(first: 999) {
      name
      slug
      id
      streamUrl
      description
    }
    seo {
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage {
        url
        id
      }
      id
    }
    instructors {
      name
      id
    }
    audiences {
      name
      description
      id
    }
    keyTakeaways
    imagesGrid {
      images {
        ...Image
        id
      }
      id
    }
    reasons {
      name
      description
      id
    }
    instructors {
      name
      description
      jobTitle
      portraitSquare {
        ...Image
        id
      }
      id
    }
  }
}

fragment Image on Asset {
  url(transformation: {document: {output: {format: webp}}})
  sm: url(
    transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}}
  )
  md: url(
    transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}}
  )
  lg: url(
    transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}}
  )
  xl: url(
    transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}}
  )
  social: url(
    transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}}
  )
  width
  id
  __typename
}
`,

    "rootType": "Query",

    "selection": {
        "fields": {
            "course": {
                "type": "Course",
                "keyRaw": "course(where: {slug: $slug})",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "keyTakeaways": {
                            "type": "String",
                            "keyRaw": "keyTakeaways",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        },

                        "outline": {
                            "type": "String",
                            "keyRaw": "outline",
                            "nullable": true,
                            "visible": true
                        },

                        "shortDescription": {
                            "type": "String",
                            "keyRaw": "shortDescription",
                            "nullable": true,
                            "visible": true
                        },

                        "slug": {
                            "type": "String",
                            "keyRaw": "slug",
                            "nullable": true,
                            "visible": true
                        },

                        "updatedAt": {
                            "type": "DateTime",
                            "keyRaw": "updatedAt",
                            "visible": true
                        },

                        "publishedDate": {
                            "type": "Date",
                            "keyRaw": "publishedDate",
                            "nullable": true,
                            "visible": true
                        },

                        "thumbnail": {
                            "type": "Asset",
                            "keyRaw": "thumbnail",

                            "selection": {
                                "fields": {
                                    "url": {
                                        "type": "String",
                                        "keyRaw": "url(transformation: {document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "sm": {
                                        "type": "String",
                                        "keyRaw": "sm(transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "md": {
                                        "type": "String",
                                        "keyRaw": "md(transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "lg": {
                                        "type": "String",
                                        "keyRaw": "lg(transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "xl": {
                                        "type": "String",
                                        "keyRaw": "xl(transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "social": {
                                        "type": "String",
                                        "keyRaw": "social(transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}})",
                                        "visible": true
                                    },

                                    "width": {
                                        "type": "Float",
                                        "keyRaw": "width",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "Image": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        },

                        "featuredThumbnail": {
                            "type": "Asset",
                            "keyRaw": "featuredThumbnail",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "url": {
                                        "type": "String",
                                        "keyRaw": "url(transformation: {document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "sm": {
                                        "type": "String",
                                        "keyRaw": "sm(transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "md": {
                                        "type": "String",
                                        "keyRaw": "md(transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "lg": {
                                        "type": "String",
                                        "keyRaw": "lg(transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "xl": {
                                        "type": "String",
                                        "keyRaw": "xl(transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "social": {
                                        "type": "String",
                                        "keyRaw": "social(transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}})",
                                        "visible": true
                                    },

                                    "width": {
                                        "type": "Float",
                                        "keyRaw": "width",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "Image": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        },

                        "skillLevel": {
                            "type": "SkillLevel",
                            "keyRaw": "skillLevel",
                            "nullable": true,
                            "visible": true
                        },

                        "timeToComplete": {
                            "type": "String",
                            "keyRaw": "timeToComplete",
                            "nullable": true,
                            "visible": true
                        },

                        "lessons": {
                            "type": "Lesson",
                            "keyRaw": "lessons(first: 999)",

                            "selection": {
                                "fields": {
                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "slug": {
                                        "type": "String",
                                        "keyRaw": "slug",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "streamUrl": {
                                        "type": "String",
                                        "keyRaw": "streamUrl",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "seo": {
                            "type": "Seo",
                            "keyRaw": "seo",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "metaTitle": {
                                        "type": "String",
                                        "keyRaw": "metaTitle",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "metaDescription": {
                                        "type": "String",
                                        "keyRaw": "metaDescription",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "ogTitle": {
                                        "type": "String",
                                        "keyRaw": "ogTitle",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "ogDescription": {
                                        "type": "String",
                                        "keyRaw": "ogDescription",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "ogImage": {
                                        "type": "Asset",
                                        "keyRaw": "ogImage",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "url": {
                                                    "type": "String",
                                                    "keyRaw": "url",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "ID",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "instructors": {
                            "type": "Instructor",
                            "keyRaw": "instructors",

                            "selection": {
                                "fields": {
                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "jobTitle": {
                                        "type": "String",
                                        "keyRaw": "jobTitle",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "portraitSquare": {
                                        "type": "Asset",
                                        "keyRaw": "portraitSquare",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "url": {
                                                    "type": "String",
                                                    "keyRaw": "url(transformation: {document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "sm": {
                                                    "type": "String",
                                                    "keyRaw": "sm(transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "md": {
                                                    "type": "String",
                                                    "keyRaw": "md(transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "lg": {
                                                    "type": "String",
                                                    "keyRaw": "lg(transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "xl": {
                                                    "type": "String",
                                                    "keyRaw": "xl(transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "social": {
                                                    "type": "String",
                                                    "keyRaw": "social(transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}})",
                                                    "visible": true
                                                },

                                                "width": {
                                                    "type": "Float",
                                                    "keyRaw": "width",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "ID",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "__typename": {
                                                    "type": "String",
                                                    "keyRaw": "__typename",
                                                    "visible": true
                                                }
                                            },

                                            "fragments": {
                                                "Image": {
                                                    "arguments": {}
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "audiences": {
                            "type": "Audience",
                            "keyRaw": "audiences",

                            "selection": {
                                "fields": {
                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "imagesGrid": {
                            "type": "ImagesGrid",
                            "keyRaw": "imagesGrid",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "images": {
                                        "type": "Asset",
                                        "keyRaw": "images",

                                        "selection": {
                                            "fields": {
                                                "url": {
                                                    "type": "String",
                                                    "keyRaw": "url(transformation: {document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "sm": {
                                                    "type": "String",
                                                    "keyRaw": "sm(transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "md": {
                                                    "type": "String",
                                                    "keyRaw": "md(transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "lg": {
                                                    "type": "String",
                                                    "keyRaw": "lg(transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "xl": {
                                                    "type": "String",
                                                    "keyRaw": "xl(transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "social": {
                                                    "type": "String",
                                                    "keyRaw": "social(transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}})",
                                                    "visible": true
                                                },

                                                "width": {
                                                    "type": "Float",
                                                    "keyRaw": "width",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "ID",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "__typename": {
                                                    "type": "String",
                                                    "keyRaw": "__typename",
                                                    "visible": true
                                                }
                                            },

                                            "fragments": {
                                                "Image": {
                                                    "arguments": {}
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "reasons": {
                            "type": "Reason",
                            "keyRaw": "reasons",

                            "selection": {
                                "fields": {
                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "slug": "String"
        },

        "types": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=46ed0a5b2bb4a9409757e83f949f8ec3298e74ff5ee3f88a7c9717e61d508af8";